import React from "react";
import { H1 } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";

const GoogleWizardHeader = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Meta" });
  return (
    <div>
      <H1>
        {/* Same single-colour headline as the Meta wizard - see MetaWizardHeader. */}
        <Trans components={{ span: <span /> }} i18nKey="Headline google" t={t} />
      </H1>
    </div>
  );
};

export default GoogleWizardHeader;
